module.exports = __webpack_public_path__ + "img/md5v5_en.debaffdb.png";